import React from "react";
import { Button, Card, Col, Form, ListGroup, Modal, Row } from "react-bootstrap";

const SoundNotificationSettings = ({
  Show,
  Hide,
  Title,
  plateformSettings,
  addUpdatePlateformSettings,
}) => {
  return (
    <>
      <Modal show={Show} onHide={() => Hide()}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 15 }}>{Title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="overflow-auto" style={{height: "calc(100vh - 180px)"}}>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <small>Desktop notifications</small>
            <Form.Check
              type="switch"
              checked={!!plateformSettings?.desktopNotification}
              onChange={() =>
                addUpdatePlateformSettings(
                  "desktopNotification",
                  !plateformSettings?.desktopNotification,
                )
              }
            />
          </div>

          <div className="d-flex justify-content-between align-items-center mb-2">
            <small>Sound notifications</small>
            <Form.Check
              type="switch"
              checked={!!plateformSettings?.soundNotification}
              onChange={() =>
                addUpdatePlateformSettings(
                  "soundNotification",
                  !plateformSettings?.soundNotification,
                )
              }
            />
          </div>
          <Card className="mb-2">
            <Card.Header style={{ fontSize: 14 }}>New Chat</Card.Header>
            <Card.Body>
              <Row>
                <Col>
                  <Form.Group className="mb-2">
                    <Form.Label>Sound</Form.Label>
                    <Form.Select style={{ fontSize: 12 }}>
                      <option>None</option>
                      <option>None</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label>Repeat</Form.Label>
                    <Form.Select style={{ fontSize: 12 }}>
                      <option>1 Times</option>
                      <option>2 Times</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-2">
                    <Form.Label>Volume</Form.Label>
                    <Form.Range />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label>Desktop Notification</Form.Label>
                    <Form.Switch type="switch" />
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <Card className="mb-2">
            <Card.Header style={{ fontSize: 14 }}>New Visitor</Card.Header>
            <Card.Body>
              <Row>
                <Col>
                  <Form.Group className="mb-2">
                    <Form.Label>Sound</Form.Label>
                    <Form.Select style={{ fontSize: 12 }}>
                      <option>None</option>
                      <option>None</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-2">
                    <Form.Label>Volume</Form.Label>
                    <Form.Range />
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <Card className="mb-2">
            <Card.Header style={{ fontSize: 14 }}>New Message</Card.Header>
            <Card.Body>
              <Row>
                <Col>
                  <Form.Group className="mb-2">
                    <Form.Label>Sound</Form.Label>
                    <Form.Select style={{ fontSize: 12 }}>
                      <option>None</option>
                      <option>None</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label>Desktop Notification</Form.Label>
                    <Form.Switch type="switch" />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-2">
                    <Form.Label>Volume</Form.Label>
                    <Form.Range />
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <Card className="mb-2">
            <Card.Header style={{ fontSize: 14 }}>Agent Disconnect</Card.Header>
            <Card.Body>
              <Row>
                <Col>
                  <Form.Group className="mb-2">
                    <Form.Label>Sound</Form.Label>
                    <Form.Select style={{ fontSize: 12 }}>
                      <option>None</option>
                      <option>None</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-2">
                    <Form.Label>Volume</Form.Label>
                    <Form.Range />
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <Card className="mb-2">
            <Card.Header style={{ fontSize: 14 }}>
              New Agent Message
            </Card.Header>
            <Card.Body>
              <Row>
                <Col>
                  <Form.Group className="mb-2">
                    <Form.Label>Sound</Form.Label>
                    <Form.Select style={{ fontSize: 12 }}>
                      <option>None</option>
                      <option>None</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label>Desktop Notification</Form.Label>
                    <Form.Switch type="switch" />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-2">
                    <Form.Label>Volume</Form.Label>
                    <Form.Range />
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Modal.Body>
        <Modal.Footer className="p-1">
          <Button size="sm" variant="outline-danger" style={{ fontSize: 12 }}>
            Reset
          </Button>
          <Button
            size="sm"
            variant="primary"
            style={{
              fontSize: 12,
            }}
          >
            Apply
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SoundNotificationSettings;
